
<div class="card">
  <div class="card-header card-header-squirrel">
    <h4>Erstelltes neues Token</h4>        
  </div>
  
  <div class="card-body">
      <!-- <form [formGroup]="tokenForm" novalidate> -->
          <div class="row container">
              <!-- <div class="col-md-12">
                <output formControlName="apiToken">{{data}}</output>
              </div> -->
              <div class="output">{{data}}</div>
            </div>

          <div class="row">
            <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px"  matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                (click)="cancel()" >Abbruch</button>
            </a>                                                
            <span style="flex: 1 1 auto"></span>
            <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Neues Token erstellen und in die Zwischenablage kopieren"
                                    (click)="copy()" >Erstellen/Kopieren</button>
            </a>                   
          </div>    
      <!-- </form> -->
  </div>
</div>



